import { Decorable, GConstructor } from "./general";

export interface EmbedPayload {
  embedSrc: string;
}

export interface EmbedMixinPayload {
  __embedSrc: string;
}

export type SerializedEmbed = {
  embedSrc: string;
};

type EmbedCtor = GConstructor<Decorable & EmbedMixinPayload>;

export function EmbedMixin<TBase extends EmbedCtor>(Base: TBase) {
  return class Embed extends Base {
    __src!: string;

    constructor(...args: any[]) {
      const [embedSrc, ...rest] = args;
      super(...rest);
      this.__embedSrc = embedSrc || '';
    }
  };
}

type Embed = InstanceType<ReturnType<typeof EmbedMixin<EmbedCtor>>>;

export const $isEmbedNode = (node: unknown): node is Embed => {
  return Boolean(node && typeof node === 'object' && '__embedSrc' in node);
}